import {RebateDiscountType} from 'desktop/pages/cart/types';

/**
 * Get next lvl rebate discount for product by count of boxes
 */
export const getNextLvlRebateDiscount = (
    rebateDiscounts: RebateDiscountType[] = [],
    countOfBoxes: number,
) => {
    const upgradeRebateItems = rebateDiscounts.filter(item => item.qty > countOfBoxes);

    const nextUpgradeRebateItem = upgradeRebateItems.reduce(
        (acc: RebateDiscountType | null, item) => {
            if (!acc) return item;

            return item.qty > acc.qty ? acc : item;
        },
        null,
    );

    if (!nextUpgradeRebateItem) return null;

    return {
        discount: nextUpgradeRebateItem.discount,
        qtyToDiscount: nextUpgradeRebateItem.qty - countOfBoxes,
    };
};

/**
 * Get applied rebate discount for product by count of boxes
 */
export const getCurrentRebateDiscount = (
    rebateDiscounts: RebateDiscountType[] = [],
    countOfBoxes: number,
) =>
    rebateDiscounts
        .filter(item => item.qty <= countOfBoxes)
        .reduce((acc: number | null, {discount}) => {
            if (!acc) return Number(discount);
            return Math.max(acc, Number(discount));
        }, null);
